import { useCallback, useMemo } from 'react';
import { Icon, Modal, Paragraph, Space } from 'ui';

type P = {
  onSendPassword: () => void;
};

export const useEmailCodeLoginModal = () => {
  const [modal, contextHolder] = Modal.useModal();

  const showEmailCodeLoginModal = useCallback(
    ({ onSendPassword }: P) => {
      modal.confirm({
        content: (
          // TODO: this 22 is size of one line
          <Space size={22} vertical>
            <Paragraph>
              You&apos;ll sign in with a one-time password sent to your email. After you&apos;re logged in, you can
              create a passkey so next time you can log in with biometric authentication or your device&apos;s screen
              lock.
            </Paragraph>
            <Paragraph>
              Passkeys are faster and more secure than passwords and protect you against phishing and other common
              attacks.
            </Paragraph>
            <Paragraph>You can set up a passkey anytime in Account → Settings → Passkeys.</Paragraph>
          </Space>
        ),
        icon: <Icon icon="lock-line" />,
        okText: 'Send me the password',
        onOk() {
          onSendPassword();
        },
        title: 'Log in and set up a passkey',
      });
    },
    [modal],
  );

  return useMemo(
    () => ({
      contextHolder,
      showEmailCodeLoginModal,
    }),
    [contextHolder, showEmailCodeLoginModal],
  );
};
